import req from 'utils/req';

const PAGE_SIZE = 50;

export const fetchFavoritesWithExperience = () => new Promise((resolve, reject) => {
  req(`${URL_API_HOST}/api/v3/experiences/favorites?include=experience&per_page=${PAGE_SIZE}`).get()
    .then(resolve)
    .catch(reject);
});

export function toggleFavorite(id: string, isWished: boolean): Promise<boolean> {
  if (isWished) {
    return req(`${URL_API_HOST}/api/v3/experiences/favorites`)
      .post({ experienceId: id });
  }
  return req(`${URL_API_HOST}/api/v3/experiences/favorites/${id}`)
    .delete();
}
